import styled from 'styled-components'

import Link from '../Link'

const FooterLink = styled(Link)`
  padding: 4px 0;
`

export default FooterLink
